var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button",class:( _obj = {'is-disabled': _vm.disabled, 'is-loading': _vm.loading}, _obj[_vm.clsTheme] = true, _obj ),on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{staticClass:"button-text"},[_vm._v(_vm._s(_vm.localText))]),(_vm.loading)?_c('app-icon',{staticClass:"button-loading",attrs:{"icon":"loading"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }